var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#E05A13",
    stroke: "#E05A13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3693 11.5131C10.6851 11.829 11.1972 11.829 11.5131 11.5131C11.829 11.1972 11.829 10.6851 11.5131 10.3693L9.14385 8L11.5131 5.63075C11.829 5.31488 11.829 4.80276 11.5131 4.4869C11.1972 4.17103 10.6851 4.17103 10.3693 4.4869L8 6.85615L5.63075 4.4869C5.31488 4.17103 4.80276 4.17103 4.4869 4.4869C4.17103 4.80276 4.17103 5.31488 4.4869 5.63075L6.85615 8L4.4869 10.3693C4.17103 10.6851 4.17103 11.1972 4.4869 11.5131C4.80276 11.829 5.31488 11.829 5.63075 11.5131L8 9.14385L10.3693 11.5131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ff36d2daffe2c798dc2fcd6c1459b21e.svg";
export { ForwardRef as ReactComponent };